<template>
  <div>
    <template v-if="isIndex">
      <div class="PlanBox">
        <ots-main-title></ots-main-title>
        <!-- <ots-refer
      class="mb20"
      :selectList="selectList"
      :request-form="sectionSelectParams"
      @search="getAllPlanFn"
    /> -->
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { getPagePlan } from "@/http/modules/examSet/examBatch";
export default {
  name: "",
  data() {
    return {
      tableHeader: [
        {
          title: "考试批次",
          prop: "code",
        },
        {
          title: "批次名称",
          prop: "name",
        },
        {
          title: "考试批次状态",
          prop: "planStateName",
        },
        {
          title: "考试类型",
          prop: "examTypeName",
        },
        {
          title: "场次安排",
          type: "buttons",
          btnList: [
            {
              formatter: (val) => val.row.sessionState == 1 ? "已设置" : "未设置",
              click: this.setting,
              disableFn: (val) => val.row.planState === "5" || val.row.planState === "6",
            },
            {
              title: "查看",
              click: this.look,
            },
          ],
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
      ],
      sectionSelectParams: {},
      PlanListParams: {
        order: "",
        page: 1,
        size: 10,
      },
      pagination: {
        total: 0,
        page: 1,
      },
      tableData: [],
    };
  },
  computed: {
    isIndex() {
      return this.$route.name == "sectionList";
    },
  },
  created() {
    this.getAllPlanFn();
    // this.initData();
  },
  methods: {
    async initData() {
      // 获取所有考试批次
      const planData = await this.mixin_getSelectPlan();
      this.selectList[0].data = planData;

      // 当前考试批次
      // const plan = await this.mixin_getCurrentPlanInfo();
      // this.sectionSelectParams.planId = plan.id;
      // this.getSectionList();
    },
    setting(row) {
      this.$router.push({
        path: "/sectionList/section",
        query: {
          id: row.id,
          code:row.code
        },
      });
    },
    look(row) {
      this.$router.push({
        path: "/sectionList/look",
        query: {
          id: row.id,
          code:row.code
        },
      });
    },
    changeSize(num) {
      this.PlanListParams.size = num;
      this.getAllPlanFn();
    },
    changePage(p) {
      this.PlanListParams.page = p;
      this.pagination.page = p;
      this.getAllPlanFn();
    },
    async getAllPlanFn() {
      let params = Object.assign({}, this.PlanListParams, {
        publish: 1,
        state: 1,
      });
      const { data } = await getPagePlan(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },
  },
};
</script>

<style scoped lang="sass"></style>
